import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { enableBfCache } from './app/utils/enable-bfcache';

// Drop legacy `unload` handlers (registered by the embedded Yellowfin JS API)
// so the page stays eligible for the back-forward cache and returning via the
// browser "Back" button restores it in place instead of doing a full reload.
enableBfCache();

if ( environment.production ) {
	enableProdMode();
}

bootstrapApplication( AppComponent, {
    providers: [
        importProvidersFrom( AppModule ),
    ],
} ).catch( err => console.error( err ) );